<mat-form-field appearance="outline" class="search-field">
  <app-icon matPrefix class="icon" [icon]="iconName.SEARCH" />
  <input matInput [placeholder]="placeholder()" [formControl]="searchControl" (blur)="onTouched()"/>
</mat-form-field>
